import {_} from 'lodash';
import {KOSubscriptionTracker} from "../../../../../util/KOSubscriptionTracker";
import {global} from "../../../../../appContext";
import {ObjectTypeId, SNACKBAR_DURATION_SHORT} from "../../../../../constants";
import {copyToClipboard} from "../../../../../util/misc";
import {MutableRule} from "../MutableRule";
import {IRule} from "../../../../../index";
import {nsRule} from "../nsRule";
import {storeObservable} from "../../../../../util/sessionstore";
import * as ko from "knockout";
import arrayHtml from './array.html?raw';

export let template = arrayHtml;

export interface IParams {
    ruleMutable: MutableRule
    objectTypeId: ObjectTypeId
    objectTypeIds: ObjectTypeId[]
}

export class viewModel {
    private readonly ObjectTypeId = ObjectTypeId;
    protected readonly tags: KnockoutObservableArray<string> = ko.observableArray<string>([]);
    protected readonly tag: KnockoutObservable<string> = ko.observable("");
    protected readonly kosub: KOSubscriptionTracker = new KOSubscriptionTracker();
    private readonly ruleMutable: MutableRule;
    private readonly argument: KnockoutObservable<string | number | null>;
    private readonly objectTypeId: ObjectTypeId;
    private readonly objectTypeIds: ObjectTypeId[];
    private silent: boolean = false;
    private readonly showAll: KnockoutObservable<boolean> = ko.observable(false)
    private readonly numSearchResults: KnockoutObservable<number> = storeObservable('num.search.results')

    constructor(params: IParams) {
        this.ruleMutable = params.ruleMutable;
        this.objectTypeId = params.objectTypeId;
        this.objectTypeIds = params.objectTypeIds;
        this.argument = this.ruleMutable.argument;
        this.tags(nsRule.parseArrayArgument(this.argument() ?? ''));

        this.kosub.subscribe(this.tags, () => {
            this.argument(this.tags().join(","));
        });
    }

    onSubmit() {
        const added = _(nsRule.parseArrayArgument(this.tag()))
            .filter((s: string) => !!s.trim())
            .uniq()
            .value()
        const oldArr = this.tags()
        const newArr = _([...this.tags(), ...added]).uniq().value()
        this.tags(newArr)
        const diff = _.difference(added, oldArr)
        if (diff.length) {
            global.snackbarData({message: `added subject|s:${diff.join(', ')}`, duration: SNACKBAR_DURATION_SHORT})
        }
        this.tag("")
    }

    removeTag(tag: string) {
        this.tags.remove(tag);
    }

    editTag(tag: string) {
        this.tags.remove(tag);
        this.tag(tag)
    }

    copyTag(tag: string) {
        this.tag(tag)
    }

    copyTagToClipBoard(tag: string) {
        copyToClipboard(tag, tag)
    }

    onBlur() {
        this.onSubmit();
    }

    private onPaste(vm: viewModel, evt: JQuery.Event) {
        const e = (evt as any).originalEvent as ClipboardEvent
        const inp = e.target as HTMLInputElement
        const inpVal = inp.value
        const startPos = inp.selectionStart ?? 0;
        const endPos = inp.selectionEnd ?? 0;
        const pasteVal = (e.clipboardData
            ?.getData('text') ?? '')
            .split(/[\r\n]+/gm)
            .map(nsRule.parseArrayArgument)
            .filter(Boolean)
            .join(',')
            .trim()
        const newVal: string = inpVal.substring(0, startPos)
            + pasteVal
            + inpVal.substring(endPos, inp.value.length);
        inp.value = newVal
        this.tag(newVal)
        const newCaretPos = startPos + pasteVal.length;
        inp.setSelectionRange(newCaretPos, newCaretPos)
    }

    private onNewTag(val: any) {
        this.tag(val);
        this.onSubmit();
    }

    private getTags(): string[] {
        if (this.showAll()) {
            return this.tags()
        }
        return this.tags().slice(0, this.numSearchResults());
    }

}
